import React, { SFC } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Header from '../base/header/header';
import Footer from '../base/footer/footer';
import { BASE_ROUTE } from '../../constants';
import BusinessInfo from '../../containers/business-info';
import Inbound from '../business-info/success/inbound';
import UserReturn from '../business-info/success/user-return';
import UserSignup from '../business-info/success/user-signup';
import withTracker from '../withTracking/withTracking';
import { PageType } from '../../helpers/tracking';

const App: SFC<{}> = () => (
  <BrowserRouter basename={BASE_ROUTE}>
    <div className="mx-layout-container mx-layout-centered mx-header-fixed">
      <Header />
      <main>
        <Switch>
          <Route exact path="/" component={withTracker(BusinessInfo, PageType.BusinessInfo)} />
          <Route
            path="/success/user-signup"
            component={withTracker(UserSignup, PageType.UserSignup)}
          />
          <Route
            path="/success/user-return"
            component={withTracker(UserReturn, PageType.UserReturn)}
          />
          <Route path="/success/inbound" component={withTracker(Inbound, PageType.Inbound)} />
        </Switch>
      </main>
      <Footer />
    </div>
  </BrowserRouter>
);

export default App;
